/* eslint-disable react/no-array-index-key */
import React, { useState } from "react";
import store from "../../../../../store/store";
import { ButtonGroup } from "../../../Common/styled/Button";
import { changePatientToAnonym } from "../../../../../actions/ConfigActions";
import {
	CommonButtons,
	CreateButton,
	CreateOptionsButton,
	CreateToggleButton,
	AcknowledgeButton,
	LogoutButton,
} from "../../../Header/Toolbar/ToolbarButtons";
import { getToolsetECG } from "../../../Header/Toolbar/getToolsetECG";
import useKeypressTools from "../../../../../util/useKeypressTools";
import {
	setWaveformLayout,
	setWaveformScaleFactor,
	setWaveformTimeFactor,
} from "../../../../../actions/WaveformActions";
import { screenShotECG, captureScreenShotECG, downloadScreenShotECG } from "../../../../../util/takeScreenShot";
import toolNames from "../../../Header/Toolbar/toolNames";
import { setShowHistory } from '../../../../../actions/LayoutActions';
import { CaptureDownloadDialog } from '../../../Common/CaptureDownloadDialog';
import {
	executeOnActiveViewport,
	getCrossWindowActiveViewport,
	getCrossWindowWindowId,
} from '../../crossWindow2dReferenceLines';

export const toolbarECG = ({ config, layout }) => {
	const [isEnabledTool, setIsEnabledTool] = useState(toolNames.LAYOUT_ECG_ALL);
	const [showCaptureDownload, setShowCaptureDownload] = useState(false);
	const twelvePlusOne = {
		name: "twelvePlusOne",
		obj: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 1],
	};

	const twelve = {
		name: "twelve",
		obj: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
	};

	const getIndex = () => {
		const { waveform } = store.getState();
		const index =
			waveform.waveformLayoutViewIndex === 12
				? 0
				: waveform.waveformLayoutViewIndex;
		const one = { name: "one", obj: [index] };
		return one;
	};

	const handlerSelectTool = (tool) => {
		const activeViewport = getCrossWindowActiveViewport();
		if (activeViewport && activeViewport.windowId !== getCrossWindowWindowId()
			&& [toolNames.COPY_CAPTURE, toolNames.DOWNLOAD_CAPTURE].includes(tool.name)) {
			executeOnActiveViewport(tool.name, layout.selectedViewIndex);
			return;
		}
		if (tool.name !== toolNames.HISTORY && layout.currentTool === tool.name) return;

		const { waveform } = store.getState();
		const { scaleFactor, timeFactor } = waveform;

		switch (tool.name) {
			case toolNames.ANONYMIZE: {
				store.dispatch(changePatientToAnonym());
				break;
			}
			case toolNames.INCREASE_VOLTAGE: {
				const newScale = scaleFactor < 5 ? scaleFactor + 1 : scaleFactor;
				store.dispatch(setWaveformScaleFactor(newScale));
				break;
			}
			case toolNames.DECREASE_VOLTAGE: {
				const newScale = scaleFactor > 1 ? scaleFactor - 1 : scaleFactor;
				store.dispatch(setWaveformScaleFactor(newScale));
				break;
			}
			case toolNames.INCREASE_SECONDS: {
				const newTimeFactor = timeFactor > 1 ? timeFactor - 1 : timeFactor;
				store.dispatch(setWaveformTimeFactor(newTimeFactor));
				break;
			}
			case toolNames.DECREASE_SECONDS: {
				const newTimeFactor = timeFactor < 5 ? timeFactor + 1 : timeFactor;
				store.dispatch(setWaveformTimeFactor(newTimeFactor));
				break;
			}
			case toolNames.COPY_CAPTURE: {
				screenShotECG().then(() => {});
				break;
			}
			case toolNames.DOWNLOAD_CAPTURE: {
				setShowCaptureDownload(true);
				break;
			}
			case toolNames.LAYOUT_ECG_GENERAL: {
				store.dispatch(setWaveformLayout(getIndex()));
				setIsEnabledTool(tool.name);
				break;
			}
			case toolNames.LAYOUT_ECG_12: {
				store.dispatch(setWaveformLayout(twelve));
				setIsEnabledTool(tool.name);
				break;
			}
			case toolNames.LAYOUT_ECG_ALL: {
				store.dispatch(setWaveformLayout(twelvePlusOne));
				setIsEnabledTool(tool.name);
				break;
			}
			case toolNames.HISTORY:
				store.dispatch(setShowHistory(!store.getState().layout.showHistory));
					break;
				default: {
				break;
			}
		}
	};

	const defaultProps = {
		currentTool: layout.currentTool,
		handlerSelectTool,
	};

	const toolsetECG = getToolsetECG();
	useKeypressTools(toolsetECG, handlerSelectTool);

	return (
		<>
		<ButtonGroup key="group">
			<CommonButtons config={config} layout={layout} />
			{toolsetECG.map((tool, i) => {
				switch (tool.type) {
					case "button":
						return (
							<React.Fragment key={`${tool.name}${i}`}>
								<CreateButton
									tool={tool}
									isEnabledTool={isEnabledTool}
									{...defaultProps}
								/>
							</React.Fragment>
						);
					case "toggle":
						return (
							<React.Fragment key={`${tool.name}${i}`}>
								<CreateToggleButton
									tool={tool}
									{...defaultProps}
								/>
							</React.Fragment>
						);
					case "options": {
						const resolvedOptions = typeof tool.options === 'function' ? tool.options() : tool.options;
						if (!resolvedOptions || resolvedOptions.length === 0) {
							return null;
						}
						return (
							<React.Fragment key={`${tool.name}${i}`}>
								<CreateOptionsButton
									tool={tool}
									{...defaultProps}
								/>
							</React.Fragment>
						);
					}
					default:
						return <>{console.error("tool type is not correct")}</>;
				}
			})}
			<AcknowledgeButton config={config} />
			<LogoutButton />
		</ButtonGroup>
		<CaptureDownloadDialog
			open={showCaptureDownload}
			onClose={() => setShowCaptureDownload(false)}
			getCapture={captureScreenShotECG}
			onSubmit={downloadScreenShotECG}
		/>
		</>
	);
};
